import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { bool, func, object, oneOf, oneOfType, string } from 'prop-types';

import './style.css';

function Button({
  title,
  color,
  disabled,
  href,
  selected,
  onClick,
  replace,
  target,
  to,
  className,
  children,
  parsedClassName,
}) {
  const newClassName =
    parsedClassName ||
    classNames(
      'Button',
      `Button-${color}`,
      {
        ButtonDisabled: disabled,
        [`ButtonSelected-${color}`]: selected,
      },
      className,
    );

  const toRender = title ? <p>{title}</p> : children;

  if (href) {
    return (
      <a
        className={newClassName}
        href={href}
        target={target}
      >
        {toRender}
      </a>
    );
  }

  if (to) {
    return (
      <Link
        className={newClassName}
        onClick={onClick}
        replace={replace}
        target={target}
        to={to}
      >
        {toRender}
      </Link>
    );
  }

  return (
    <div
      className={newClassName}
      onClick={onClick}
    >
      {toRender}
    </div>
  );
}

export const propTypes = {
  className: string,
  disabled: bool,
  href: string,
  onClick: func,
  replace: bool,
  selected: bool,
  size: oneOf(['X2', 'X3', 'X4', 'X5', 'X6']),
  target: string,
  title: string,
  to: oneOfType([string, object]),
};
Button.propTypes = {
  color: oneOf(['blue', 'green', 'red', 'yellow']).isRequired,
  parsedClassName: string,
  ...propTypes,
};

export const defaultProps = {
  disabled: false,
  href: null,
  onClick: undefined,
  replace: false,
  size: 'X5',
  target: undefined,
  to: null,
};

Button.defaultProps = {
  color: 'blue',
  ...defaultProps,
};

export default Button;
